

































import Vue from "vue";
import { MatchingCandidatesStatus } from "@/store/modules/recruiter/interfaces";
import { mapGetters, mapMutations } from "vuex";
import {
  JOB_GENERATION_ACCEPTED_MATCHING_CANDIDATES,
  JOB_GENERATION_REJECTED_MATCHING_CANDIDATES,
  VIEW_CANDIDATES_DYNAMICALLY
} from "@/store/modules/recruiter/constants";

export default Vue.extend({
  name: "StatusFiltersOnSmScreens",
  components: {},
  data() {
    return {};
  },
  props: {
    filter: {
      type: String,
      default: MatchingCandidatesStatus.SHORTLISTED
    },
    candidate_count: {
      type: Number,
      default: 0
    }
  },
  computed: {
    ...mapGetters("recruiter", {
      get_accepted_candidates: JOB_GENERATION_ACCEPTED_MATCHING_CANDIDATES,
      get_rejected_candidates: JOB_GENERATION_REJECTED_MATCHING_CANDIDATES
    }),
    MatchingCandidatesStatus() {
      return MatchingCandidatesStatus;
    }
  },
  methods: {
    ...mapMutations("recruiter", {
      set_candidates_view_dynamically: VIEW_CANDIDATES_DYNAMICALLY
    })
  }
});
